// extracted by mini-css-extract-plugin
export default {"root":"SectionFooterActionV2_root__2hL9C","rootTint":"SectionFooterActionV2_rootTint__2_w6J","actions":"SectionFooterActionV2_actions__Zc0Bl"};